import React , { useState,useEffect,Fragment, useContext } from 'react';
import { Element } from 'react-scroll';
import PropTypes from 'prop-types';
import { Row,Col, Button} from 'antd';
import RoomWrapper ,{ PostsWrapper, LoadMoreRoomWrapper } from './Room.style';
import SectionRoom from 'components/SectionRoom/SectionRoom';
import Heading from 'components/UI/Heading/Heading';
import Loader from 'components/Loader/Loader';
import SearchForm from './SearchForm';
import {loadState} from 'library/helpers/localStorage' ; 
import { RESERVATION_PAGE } from 'settings/constant';
import { SharedDataContext } from 'context/SharedDataProvider';
const Room = ({
  details,
  currency,
  hotel,
  roomMax,
  contentStyle,
  setParamRoom,
  paramRoom,
  loadMoreChambre,
  diplayLoadMoreBtn,
  setDiplayLoadMoreChambreBtn,
  setChambreLoaded,
  diplayLoaderToLoadMoreChambreBtn,
  remises,
}) => {
  let params = loadState("filtre") ? loadState("filtre") : null ;
  const [roomList , setRoomList] = useState(details);
  const [paramData, setParamData]=useState(params);
  const [dateSejour, setDateSejour] = useState(
    params?.date_range??{
      setStartDate: null,
      setEndDate: null,
    }
  )

  const [loader , setLoader] = useState(false) ;
  const [localDiplayLoadMoreBtn, setLocalDiplayLoadMoreBtn]=useState(diplayLoadMoreBtn);

  const [disponibiliteDateParams, setDisponibiliteDateParams]=useState(null);
  const [remiseValue, setRemiseValue]=useState(remises && remises.length>0 ? remises[0].remise : null);


  useEffect(() => {
    setRoomList(details);
  }, [details])

  useEffect(() => {
    setLocalDiplayLoadMoreBtn(diplayLoadMoreBtn);
  }, [diplayLoadMoreBtn])

  useEffect(() => {
    if (paramRoom) setRoomList(paramRoom)
  }, [paramRoom])

  //const { data, loading, loadMoreData, total, limit } = useDataApi(url);
  let columnWidth = [1 / 1, 1 / 2, 1 / 3, 1 / 4];

  return (
    <Element name="room" className="room">
    <RoomWrapper>
      
    <Heading as="h2" content="Disponibilité des chambres" />
      <Row className='search-row-room' gutter={30} >
        <SearchForm 
            param={paramData} 
            currency ={currency} 
            hotel={hotel} 
            roomMax={roomMax}
            setParamRoom={setParamRoom} 
            setLoader={setLoader} 
            loader={loader} 
            setDiplayLoadMoreChambreBtn={setDiplayLoadMoreChambreBtn}
            setChambreLoaded={setChambreLoaded}
            loadMoreChambre={loadMoreChambre}
            setDateSejour={setDateSejour}
            />
        {/* </Col> */}
      
      </Row> 
          {
            loader ?  <Loader/> : 
            <Fragment>
              {
                roomList.length > 0 ? 
                <PostsWrapper >
                    <SectionRoom
                      link={RESERVATION_PAGE}
                      columnWidth={columnWidth}
                      data={roomList}
                      totalItem={roomList.length}
                      currency={currency}
                      hotel={hotel}
                      remiseValue={remiseValue}
                      offre={remises}
                      dateSejour={dateSejour}
                      // loading={loading}
                      // limit={limit}
                      // handleLoadMore={loadMoreData}
                      // placeholder={<PostPlaceholder />}
                    />
                    {
                      localDiplayLoadMoreBtn && (
                        <LoadMoreRoomWrapper>
                          <Button 
                            loading={diplayLoaderToLoadMoreChambreBtn} 
                            onClick={()=> loadMoreChambre()}>
                            {'Afficher plus'}
                          </Button>
                        </LoadMoreRoomWrapper>
                      )
                    }

                  </PostsWrapper>
                    : 
                    <Heading as="h4" content="Aucune chambre n'est disponible. Pour afficher les chambres disponibles, veuillez ajuster vos filtres (dates d'arrivée et de départ, nombre de chambres ou nombre de voyageurs), puis cliquer sur Chercher." {...contentStyle} />

              }  
            </Fragment>
          }
    </RoomWrapper>

    </Element>
  );
};

Room.propTypes = {
  titleStyle: PropTypes.object,
  locationMetaStyle: PropTypes.object,
  contentStyle: PropTypes.object,
};

Room.defaultProps = {
  titleStyle: {
    color: '#2C2C2C',
    fontSize: ['17px', '20px', '25px'],
    lineHeight: ['1.15', '1.2', '1.36'],
    mb: '4px',
  },
  locationMetaStyle: {
    fontSize: '13px',
    fontWeight: '400',
    color: '#909090',
    mb: ['14px', '20px', '27px'],
  },
  contentStyle: {
  //  fontSize: '15px',
    fontWeight: '400',
    color: 'grey',
    lineHeight: '1.6',
    marginTop : '20px !important',
    textAlign : 'center',
    mt : '100px',
    mb: [ '14px', '20px', '27px'],
  },
  boldContentStyle: {
    fontWeight: '700',
    mb: '0!important',
  },
  linkStyle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#008489',
  },
};

export default Room;
